/**
 * Runtime API-base resolution, mirroring the rcm app's loadApiConfig() in api.ts.
 *
 * On startup we fetch the app's domain list from GET /api/config/domains (the same
 * config/domain.resolver.js that drives server CORS) and match window.location.origin
 * against each entry's callfrom[] to pick that deployment's api_base.
 *
 * `api_base` is an ORIGIN PREFIX prepended to the app's existing relative "/api/..." paths
 * (see client/src/lib/api.js). Empty string = same-origin, which is the default and the
 * current behavior for every configured deployment — so this changes nothing today; it
 * only lets a future cross-origin deployment point the SPA at an absolute API origin
 * without a rebuild. Never throws: any failure keeps the same-origin default.
 */
let API_ROOT = ''; // same-origin until loadDomainConfig() runs

export function getApiRoot() {
  return API_ROOT;
}

export async function loadDomainConfig() {
  const origin = window.location.origin;
  try {
    const res = await fetch('/api/config/domains', { cache: 'no-store' });
    if (res.ok) {
      const { data } = await res.json();
      const entries = Array.isArray(data) ? data : [];
      const match =
        entries.find((e) => e.callfrom?.includes(origin)) ??
        entries.find((e) => e.base_url === origin) ??
        entries.find((e) => e.name === 'local');
      if (match) {
        API_ROOT = match.api_base || '';
        return;
      }
    }
  } catch {
    // keep the same-origin default
  }
}
